forceUpdateState